export const FETCH_STATUS_SUCCESS = 'job/FETCH_STATUS_SUCCESS'
export const FETCH_STATUS_FAILURE = 'job/FETCH_STATUS_FAILURE'
export const FETCH_STATUS_STARTED = 'job/FETCH_STATUS_STARTED'
